import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { PasslyButton } from '..';
import { Button } from '@itglue/kaseya-ui';

interface IProps {
    proceedLabel: any;
    cancelLabel: any;
    titleLabel: any;
    proceed: any;
    cancel: any;
    dialogText: any;
    options: any;
    isHtml?: boolean;
    icons?: any;
    isDeleteAction?: boolean;
    size?: boolean;
}

export function Confirmation(props: IProps) {
    const { proceedLabel, cancelLabel, titleLabel, proceed, cancel, dialogText, isHtml, icons, isDeleteAction, size } = props;

    return (
        <>
            <div className='confirmModal__overlay'>
                <div className='confirmModal'>
                    <Modal
                        isOpen={true}
                        backdrop='static'
                        keyboard={false}
                        className={`confirmModal__wrapper confirmModal__wrapper-${size}`}
                        zIndex={9999}
                    >
                        {titleLabel ? <ModalHeader className='confirmModal__header'>{titleLabel}</ModalHeader> : null}
                        <ModalBody className='confirmModal__body'>
                            {icons}
                            {isHtml ? <div dangerouslySetInnerHTML={{ __html: dialogText }} /> : dialogText}
                        </ModalBody>
                        <ModalFooter className='confirmModal__footer'>
                            <div>
                                {cancelLabel !== '' && (
                                    <PasslyButton
                                        additionalColor='tertiary'
                                        className='modal__actions-tertiary'
                                        onClick={cancel}
                                        id='confirmSecondaryAction'
                                    >
                                        {cancelLabel}
                                    </PasslyButton>
                                )}
                                {isDeleteAction ? (
                                    <Button autoWidth={true} label={proceedLabel} variant='danger' size='regular' onClick={proceed} />
                                ) : (
                                    <PasslyButton variant='contained' color='primary' onClick={proceed} id='confirmPrimaryAction'>
                                        {proceedLabel}
                                    </PasslyButton>
                                )}
                            </div>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </>
    );
}

Confirmation.propTypes = {
    proceedLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func, // from confirmable. call to close the dialog with promise rejected.
    dialogText: PropTypes.any, // arguments of your confirm function
    options: PropTypes.object, // arguments of your confirm function
    isHtml: PropTypes.bool
};

export function confirm(dialogText: any, proceedLabel = '', cancelLabel = '', titleLabel = '', isHtml = false, options = {}) {
    return createConfirmation(confirmable(Confirmation))({
        dialogText,
        proceedLabel,
        cancelLabel,
        titleLabel,
        isHtml,
        ...options
    });
}
